import styles from '../ChallengeDetail.module.scss';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';
import image161 from './images/16-1.jpg';
import image181 from './images/18-1.jpg';
import image191 from './images/19-1.jpg';

export const CompleteRareCollectionDescription = () => {
    return (
        <div className={styles.description}>
            <p>
                <div>
                    Потратьте 12 билетов на участие в розыгрышах за синие билеты, чтобы собрать редкую коллекцию
                </div>
                <div>
                    Посмотреть коллекцию можно в разделе <b>Активы</b>
                </div>
                <ChallengeDetailHelpImage image={image161} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Подраздел <b>«Коллекции»</b>
                </div>
                <ChallengeDetailHelpImage image={image181} helpText='Это картинка. Ищите вкладку в разделе «Активы».' />
            </p>
            <p>
                <div>
                    Далее ищите
                </div>
                <ChallengeDetailHelpImage image={image191} helpText='Это картинка. Ищите редкую коллекцуию в подразделе «Коллекции».' />
            </p>
        </div>
    );
}